module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAUCAYAAADyWA/8AAAABHNCSVQICAgIfAhkiAAAAOFJREFUSIntlcERgyAQRZ/pwZFugpVFKwvpxgxFkIOo6EAUUbz4Ls4s+vetMgg3N+loQaMFTcZ+MrmfFjS6wugKk0P+kH6zkAzye/oVvhAMrz9PtGV3zBApvWbiq0EbQ/+hBRIAwzulzygeJe0JBxRA2fXXmWQvOmRPtYj8pbwrLm14fPC5KCuu3GL8Hs+LKr/UvoXHslB2NPbTX0tBG5LulwNc+Oa9W2NJUHwg6wAF9ZrwdOtGTh1gx9G6WXxg/KOlDaFs99UtESJa3MWe0xIAw9OWpXOLcjp98Jz1Nzcn8wNj1HS9Oza24AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/underline@2x.png
// module id = TPs+
// module chunks = 1